(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const page = document.querySelector('[data-cart-page]');
    if (!page) return;

    page.addEventListener('click', (event) => {
      const control = event.target.closest('[data-cart-qty]');
      if (!control) return;
      control.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: parseInt(control.getAttribute('data-line'), 10),
          quantity: Math.max(0, parseInt(control.getAttribute('data-quantity'), 10)),
        }),
      }).then(() => window.location.reload());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.nonaa-header');
    if (!header) return;

    if (header.hasAttribute('data-transparent')) {
      let ticking = false;
      const update = () => {
        const progress = Math.min(1, Math.max(0, window.scrollY / 280));
        header.style.setProperty('--header-progress', progress.toFixed(3));
        header.classList.toggle('is-scrolled', progress > 0.5);
        ticking = false;
      };
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
          }
        },
        { passive: true }
      );
      update();
    }

    const overlay = document.querySelector('[data-menu-overlay]');
    const openButton = header.querySelector('[data-menu-open]');
    if (overlay && openButton) {
      const setOpen = (open) => {
        overlay.hidden = !open;
        openButton.setAttribute('aria-expanded', String(open));
      };
      openButton.addEventListener('click', () => setOpen(true));
      overlay.querySelector('[data-menu-close]').addEventListener('click', () => setOpen(false));
      overlay.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    }

    document.addEventListener('cart:updated', (event) => {
      const badge = header.querySelector('[data-cart-count]');
      if (!badge) return;
      const count = event.detail.item_count;
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-artists"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-artist-slider]').forEach((root) => {
    const slides = root.querySelectorAll('[data-slide]');
    const count = root.querySelector('[data-slider-count]');
    if (slides.length < 2) return;
    let index = 0;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    };

    root.querySelector('[data-slider-prev]').addEventListener('click', () => show(index - 1));
    root.querySelector('[data-slider-next]').addEventListener('click', () => show(index + 1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const refresh = async () => {
      try {
        const response = await fetch(`${window.location.pathname}?sections=nonaa-cart-drawer`);
        const sections = await response.json();
        const parsed = new DOMParser().parseFromString(sections['nonaa-cart-drawer'], 'text/html');
        const fresh = parsed.querySelector('[data-cart-drawer-content]');
        drawer.querySelector('[data-cart-drawer-content]').replaceWith(fresh);
      } catch (error) {
        // leave current content in place
      }
    };

    // The header cart icon opens the drawer (href /cart stays as fallback)
    document.querySelectorAll('.nonaa-header__cart').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        drawer.showModal();
      });
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
      if (event.target.closest('[data-cart-drawer-close]')) drawer.close();

      const control = event.target.closest('[data-cart-qty]');
      if (control) {
        const quantity = Math.max(0, parseInt(control.getAttribute('data-quantity'), 10));
        control.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(control.getAttribute('data-line'), 10), quantity }),
        })
          .then((response) => response.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
            return refresh();
          })
          .catch(() => refresh());
      }
    });

    // Keep the drawer fresh after add-to-cart elsewhere on the page
    document.addEventListener('cart:updated', () => {
      if (!drawer.open) refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cta-add]').forEach((button) => {
    button.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('product:add'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-popup"]) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-popup]');
    if (!popup) return;

    const SHOWN_KEY = 'nonaa_popup_shown';
    const SUBSCRIBED_KEY = 'nonaa_popup_subscribed';
    const THANKS_KEY = 'nonaa_popup_thanks';

    const markShown = () => {
      try {
        localStorage.setItem(SHOWN_KEY, '1');
      } catch (error) {
        // private mode: popup simply shows again next time
      }
    };

    popup.addEventListener('close', markShown);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) popup.close();
      if (event.target.closest('[data-popup-close]')) popup.close();
    });

    // Remember a subscription at submit time, and flag the follow-up
    // page load to reopen once with the thank-you message
    const popupForm = popup.querySelector('[data-popup-form]');
    if (popupForm) {
      popupForm.addEventListener('submit', () => {
        try {
          localStorage.setItem(SUBSCRIBED_KEY, '1');
          sessionStorage.setItem(THANKS_KEY, '1');
        } catch (error) {
          // ignore
        }
        markShown();
      });
    }

    // In the theme editor: only open while the section is selected
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(popup)) popup.showModal();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(popup) && popup.open) popup.close();
      });
      return;
    }

    let shown = null;
    let subscribed = null;
    let thanks = null;
    try {
      shown = localStorage.getItem(SHOWN_KEY);
      subscribed = localStorage.getItem(SUBSCRIBED_KEY);
      thanks = sessionStorage.getItem(THANKS_KEY);
    } catch (error) {
      return;
    }

    // One-time reopen right after subscribing, to show the thank-you
    if (thanks && popup.querySelector('[data-popup-success]')) {
      sessionStorage.removeItem(THANKS_KEY);
      popup.showModal();
      return;
    }
    sessionStorage.removeItem(THANKS_KEY);

    if (shown || subscribed) return;

    const delay = (parseInt(popup.getAttribute('data-delay'), 10) || 6) * 1000;
    setTimeout(() => {
      if (!popup.open) {
        popup.showModal();
        markShown();
      }
    }, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-product-highlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Gallery arrows (desktop); on mobile the track is swipeable
    const track = document.querySelector('[data-quickshop-track]');
    if (track) {
      const slideTo = (direction) => {
        const width = track.clientWidth;
        const maxScroll = track.scrollWidth - width;
        let target = track.scrollLeft + direction * width;
        if (target > maxScroll + 10) target = 0;
        if (target < -10) target = maxScroll;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      };
      const quickshopPrev = document.querySelector('[data-quickshop-prev]');
      if (quickshopPrev) quickshopPrev.addEventListener('click', () => slideTo(-1));
      const quickshopNext = document.querySelector('[data-quickshop-next]');
      if (quickshopNext) quickshopNext.addEventListener('click', () => slideTo(1));
    }

    const form = document.querySelector('[data-quickshop-form]');
    if (!form) return;
    if (form.getAttribute('data-sale-mode') === 'coming_soon') {
      form.addEventListener('submit', (event) => event.preventDefault());
      return;
    }
    const section = form.closest('.nonaa-quickshop');

    form.querySelectorAll('input[name="id"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const price = section.querySelector('[data-price]');
        if (price) price.textContent = radio.getAttribute('data-variant-price');
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const addButton = form.querySelector('[data-add-button]');
      addButton.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('add failed');
        const cart = await (await fetch('/cart.js')).json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
        addButton.hidden = true;
        form.querySelector('[data-added]').hidden = false;
        form.querySelector('[data-view-cart]').hidden = false;
      } catch (error) {
        form.submit();
      } finally {
        addButton.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-sessions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.nonaa-sessions');
    if (!root) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const strength = parseFloat(getComputedStyle(root).getPropertyValue('--parallax-strength')) || 0;
    if (strength <= 0) return;

    const tick = () => {
      const vh = window.innerHeight;
      const disabled = window.innerWidth < 900;
      root.querySelectorAll('[data-parallax]').forEach((el) => {
        const current = parseFloat(el.dataset.py || '0');
        if (disabled) {
          if (current !== 0) {
            el.style.transform = 'none';
            el.dataset.py = '0';
          }
          return;
        }
        const rect = el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        const center = rect.top + rect.height / 2 - current;
        const progress = (center - vh / 2) / vh;
        const target = -progress * parseFloat(el.dataset.speed || '12') * strength;
        const next = current + (target - current) * 0.1;
        el.dataset.py = String(next);
        el.style.transform = `translateY(${next.toFixed(2)}px)`;
      });
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nonaa-slider-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nonaa-slider-text').forEach((root) => {
    const video = root.querySelector('.nonaa-slider-text__video');
    if (video) {
      const playButton = root.querySelector('[data-video-play]');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Only the poster, with a manual play toggle
        playButton.hidden = false;
        playButton.addEventListener('click', () => {
          const playing = !video.paused;
          if (playing) {
            video.pause();
          } else {
            video.play();
          }
          playButton.setAttribute('aria-pressed', String(!playing));
        });
      } else {
        // Lazy: only load and play once scrolled into view, pause off-screen
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.15 }
        );
        observer.observe(video);
      }
    }

    const slides = root.querySelectorAll('[data-slide]');
    const count = root.querySelector('[data-slider-count]');
    if (slides.length < 2) return;
    let index = 0;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    };

    const sliderPrev = root.querySelector('[data-slider-prev]');
    if (sliderPrev) sliderPrev.addEventListener('click', () => show(index - 1));
    const sliderNext = root.querySelector('[data-slider-next]');
    if (sliderNext) sliderNext.addEventListener('click', () => show(index + 1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.querySelectorAll('[data-password-open]').forEach((button) => {
    const dialog = document.getElementById(button.getAttribute('data-password-open'));
    if (!dialog) return;
    button.addEventListener('click', () => dialog.showModal());
  });

  // Reopen the dialog after a failed password submit so the error is visible
  document.querySelectorAll('dialog.coming-soon__dialog').forEach((dialog) => {
    if (dialog.querySelector('[data-password-error]')) dialog.showModal();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const form = document.getElementById('nonaa-product-form');
    if (!form) return;
    const comingSoon = form.getAttribute('data-sale-mode') === 'coming_soon';

    // View switcher: crossfade on desktop, snap-scroll track on mobile
    const views = document.querySelector('.nonaa-pdp__views');
    const thumbTrack = document.querySelector('.nonaa-pdp__thumbs');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const mediaCount = document.querySelectorAll('[data-view]').length;
    const mobileStage = window.matchMedia('(max-width: 900px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const markActiveThumb = (index) => {
      thumbs.forEach((thumb) => {
        thumb.toggleAttribute('data-active', thumb.getAttribute('data-thumb') === String(index));
      });
      // Scroll only the thumbnail strip itself into position - never scrollIntoView,
      // which can also nudge the page's own vertical scroll while swiping the main image.
      if (!thumbTrack) return;
      const activeThumb = thumbTrack.querySelector(`[data-thumb="${index}"]`);
      if (!activeThumb) return;
      const trackRect = thumbTrack.getBoundingClientRect();
      const thumbRect = activeThumb.getBoundingClientRect();
      const offset = thumbRect.left - trackRect.left - (trackRect.width - thumbRect.width) / 2;
      thumbTrack.scrollBy({ left: offset, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    const goToView = (index) => {
      if (mobileStage.matches && views) {
        views.scrollTo({
          left: views.clientWidth * parseInt(index, 10),
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });
      } else {
        document.querySelectorAll('[data-view]').forEach((view) => {
          view.toggleAttribute('data-active', view.getAttribute('data-view') === String(index));
        });
      }
      markActiveThumb(String(index));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goToView(thumb.getAttribute('data-thumb')));
    });

    // While swiping on mobile, keep the active thumbnail in sync
    if (views) {
      views.addEventListener(
        'scroll',
        () => {
          if (!mobileStage.matches) return;
          markActiveThumb(String(Math.round(views.scrollLeft / views.clientWidth)));
        },
        { passive: true }
      );
    }

    // Arrow buttons step through the media, wrapping around at either end
    const getCurrentIndex = () => {
      const active = document.querySelector('[data-thumb][data-active]');
      return active ? parseInt(active.getAttribute('data-thumb'), 10) : 0;
    };

    const prevButton = document.querySelector('[data-view-prev]');
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        goToView((getCurrentIndex() - 1 + mediaCount) % mediaCount);
      });
    }

    const nextButton = document.querySelector('[data-view-next]');
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goToView((getCurrentIndex() + 1) % mediaCount);
      });
    }

    // Keep sticky bar size/price in sync with the picked variant
    form.querySelectorAll('input[name="id"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const size = document.querySelector('[data-sticky-size]');
        if (size) size.textContent = radio.getAttribute('data-variant-title');
        document.querySelectorAll('[data-price]').forEach((price) => {
          price.textContent = radio.getAttribute('data-variant-price');
        });
      });
    });

    // AJAX add to cart with full-page fallback
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (comingSoon) return;
      const buttons = document.querySelectorAll('[data-add-button]');
      buttons.forEach((button) => (button.disabled = true));
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('add failed');
        const cart = await (await fetch('/cart.js')).json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
        buttons.forEach((button) => (button.hidden = true));
        document.querySelectorAll('[data-added]').forEach((added) => (added.hidden = false));
      } catch (error) {
        form.submit();
      } finally {
        buttons.forEach((button) => (button.disabled = false));
      }
    });

    // CTA sections elsewhere on the page can trigger the buy flow
    document.addEventListener('product:add', () => {
      if (!comingSoon) form.requestSubmit();
    });

    // Size guide dialog
    const dialog = document.querySelector('[data-size-guide]');
    document.querySelectorAll('[data-size-guide-open]').forEach((button) => {
      button.addEventListener('click', () => dialog.showModal());
    });
    if (dialog) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
